import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { NetworkAppContainerController } from '../controller/NetworkAppContainerController';
import { translateFn } from '../../../utils/translator.helper';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { getTimezone } from '../../../utils/global.utils';
import { NetworkGridAppExternalParams } from '../helpers/types';

export class NetworkAppContainerWebComponent extends BaseWebComponentElement {
  private _externalParams: NetworkGridAppExternalParams = {};

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: NetworkAppContainerController,
    });

    this.injectDependencies({ api: { type: API_TYPE_GZ }, translateFn: translateFn, getTimezone: getTimezone });
  }

  set externalParams(params: NetworkGridAppExternalParams) {
    this._externalParams = params;
  }

  get externalParams(): NetworkGridAppExternalParams {
    return this._externalParams;
  }

  hasExternalParams(): boolean {
    return !!Object.keys(this._externalParams).length;
  }
}
